import React from 'react'
import YandexMetrika from './YandexMetrika'

export interface MetricsProps {}

export const Metrics: React.FC<MetricsProps> = () => (
  <>
    <YandexMetrika />
  </>
)
